import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=3afe8baa&scoped=true&"
import script from "./Topbar.vue?vue&type=script&lang=js&"
export * from "./Topbar.vue?vue&type=script&lang=js&"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=3afe8baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe8baa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterModalIcon: require('/opt/build/repo/components/patientFilters/svg/filterModalIcon.vue').default,PatientFilterModal: require('/opt/build/repo/components/patientFilters/patientFilterModal.vue').default})
